<template>
  <div style="overflow: hidden">
    <div id="mySoftphone" style="width: 80%; display: none"></div>
    <div class="recondMain" id="bigdata">
      <div class="quanp">
        <el-button id="fullScreen" @click="showFullScreen" type="primary"
          >{{ onFullScreen ? "退出全屏" : "进入全屏" }}
        </el-button>
      </div>
      <div class="recondTop">
        <img src="../../../assets/supervise/state07.png" alt="" srcset="" />
      </div>
      <div class="recondContent">
        <div class="contentLeft">
          <div class="leftItem leftItem1">
            <div class="recondTitle">话务统计</div>
            <img
              src="../../../assets/supervise/leftBox1.png"
              alt=""
              srcset=""
              class="reconbg"
            />
            <div id="trafficWay"></div>
          </div>
          <div class="leftItem leftItem1">
            <div class="recondTitle">话务监管</div>
            <img
              src="../../../assets/supervise/leftBox1.png"
              alt=""
              srcset=""
              class="reconbg"
            />
            <iframe
              :src="`https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/${this.vodelist[0].sequence}/${this.vodelist[0].channel}.live&autoplay=1&audio=1&accessToken=${this.vodelist[0].token}&templete=2`"
              width="380"
              height="240"
              id="ysopen"
              style="position: relative; z-index: 2000"
              allowfullscreen
            >
            </iframe>
          </div>
          <div class="leftItem leftItem2">
            <div class="recondTitle">进线时间段分析</div>
            <img
              src="../../../assets/supervise/leftBox2.png"
              alt=""
              srcset=""
              class="reconbg"
            />
            <div id="timeAnalysis"></div>
            <!-- <img
                            src="../../../assets/supervise/videos.png"
                            class="videoImg"
                            alt=""
                            srcset=""
                        /> -->
          </div>
        </div>
        <div class="contentRight">
          <div class="rightTop">
            <div class="topItem">
              <img
                src="../../../assets/supervise/rightTop.png"
                class="rightImg"
                alt=""
                srcset=""
              />
              <div class="statisticsBox">
                <img
                  src="../../../assets/supervise/phone1.png"
                  class="icons"
                  alt=""
                  srcset=""
                />
                <div class="statisticsFlex">
                  <p class="name">闲置人数</p>
                  <p class="sums">{{ worksInfo.count2 }}个</p>
                </div>
              </div>
            </div>
            <div class="topItem">
              <img
                src="../../../assets/supervise/rightTop.png"
                class="rightImg"
                alt=""
                srcset=""
              />
              <div class="statisticsBox">
                <img
                  src="../../../assets/supervise/phone2.png"
                  class="icons"
                  alt=""
                  srcset=""
                />
                <div class="statisticsFlex">
                  <p class="name">置忙人数</p>
                  <p class="sums">{{ worksInfo.count1 }}个</p>
                </div>
              </div>
            </div>
            <div class="topItem">
              <img
                src="../../../assets/supervise/rightTop.png"
                class="rightImg"
                alt=""
                srcset=""
              />
              <div class="statisticsBox">
                <img
                  src="../../../assets/supervise/phone3.png"
                  class="icons"
                  alt=""
                  srcset=""
                />
                <div class="statisticsFlex">
                  <p class="name">通话保持</p>
                  <p class="sums">{{ worksInfo.count3 }}个</p>
                </div>
              </div>
            </div>
            <div class="topItem">
              <img
                src="../../../assets/supervise/rightTop.png"
                class="rightImg"
                alt=""
                srcset=""
              />
              <div class="statisticsBox">
                <img
                  src="../../../assets/supervise/phone4.png"
                  class="icons"
                  alt=""
                  srcset=""
                />
                <div class="statisticsFlex">
                  <p class="name">小休人数</p>
                  <p class="sums">{{ worksInfo.count6 }}个</p>
                </div>
              </div>
            </div>
            <div class="topItem">
              <img
                src="../../../assets/supervise/rightTop.png"
                class="rightImg"
                alt=""
                srcset=""
              />
              <div class="statisticsBox">
                <img
                  src="../../../assets/supervise/phone5.png"
                  class="icons"
                  alt=""
                  srcset=""
                />
                <div class="statisticsFlex">
                  <p class="name">离线人数</p>
                  <p class="sums">{{ worksInfo.count0 }}个</p>
                </div>
              </div>
            </div>
          </div>
          <div class="rightMain">
            <div class="rightFlex">
              <ul class="recondTotal">
                <li>
                  总话务量：<span class="men">{{ worksInfo.allCount }}</span
                  >单
                </li>
                <li>
                  总服务对象：<span class="total">{{
                    worksInfo.oldManCount
                  }}</span
                  >人
                </li>
              </ul>
              <div class="bg-particles">
                <img src="" alt="" />
                <!--                <div>-->
                <!--                  <vue-particles-->
                <!--                    color='#2D5576'-->
                <!--                    :particleOpacity='1'-->
                <!--                    :particlesNumber='100'-->
                <!--                    shapeType='circle'-->
                <!--                    :particleSize='5'-->
                <!--                    linesColor='#69769D'-->
                <!--                    :linesWidth='1'-->
                <!--                    :lineLinked='true'-->
                <!--                    :lineOpacity='0.4'-->
                <!--                    :linesDistance='150'-->
                <!--                    :moveSpeed='5'-->
                <!--                    :hoverEffect='true'-->
                <!--                    hoverMode='grab'-->
                <!--                    :clickEffect='true'-->
                <!--                    clickMode='push'-->
                <!--                    class='login'-->
                <!--                  >-->
                <!--                  </vue-particles>-->
                <!--                </div>-->
                <img src="../../../assets/supervise/qiu.png" alt="" />
                <div class="mapCity" id="mapCity"></div>
              </div>
            </div>
            <div class="rightEachrt">
              <div class="rightItem rightItem1">
                <div class="recondTitle">坐席状态</div>
                <img
                  src="../../../assets/supervise/rightBox1.png"
                  alt=""
                  srcset=""
                  class="reconbg"
                />
                <ul class="numUl">
                  <li class="numLi">
                    <p class="numImg">
                      <img
                        src="../../../assets/supervise/huawuIcon.png"
                        alt=""
                        srcset=""
                      />
                    </p>
                    <el-select
                      v-model="notReady"
                      placeholder="暂无数据"
                      class="numSelect"
                      popper-class="serveDrops"
                      @change="changeReady"
                    >
                      <el-option
                        v-for="(item, index) in readyList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <p class="numPhone">{{ readyPhone }}</p>
                  </li>
                  <li class="numLi">
                    <p class="numImg">
                      <img
                        src="../../../assets/supervise/huawuIcon1.png"
                        alt=""
                        srcset=""
                      />
                    </p>
                    <el-select
                      v-model="freeName"
                      placeholder="暂无数据"
                      class="numSelect"
                      popper-class="serveDrops"
                      @change="changeFree"
                    >
                      <el-option
                        v-for="(item, index) in freeList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <p class="numPhone">{{ freePhone }}</p>
                  </li>
                  <li class="numLi">
                    <p class="numImg">
                      <img
                        src="../../../assets/supervise/huawuIcon2.png"
                        alt=""
                        srcset=""
                      />
                    </p>
                    <el-select
                      v-model="registerName"
                      placeholder="暂无数据"
                      class="numSelect"
                      popper-class="serveDrops"
                      @change="changeRegister"
                    >
                      <el-option
                        v-for="(item, index) in registerList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <p class="numPhone">
                      {{ registerPhone }}
                    </p>
                  </li>
                  <li class="numLi">
                    <p class="numImg">
                      <img
                        src="../../../assets/supervise/huawuIcon3.png"
                        alt=""
                        srcset=""
                      />
                    </p>
                    <el-select
                      v-model="keepName"
                      placeholder="暂无数据"
                      class="numSelect"
                      popper-class="serveDrops"
                      @change="changeKeep"
                    >
                      <el-option
                        v-for="(item, index) in keepList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <p class="numPhone">{{ keepPhone }}</p>
                  </li>
                  <li class="numLi">
                    <p class="numImg">
                      <img
                        src="../../../assets/supervise/huawuIcon4.png"
                        alt=""
                        srcset=""
                      />
                    </p>
                    <el-select
                      v-model="vacationetteName"
                      placeholder="暂无数据"
                      class="numSelect"
                      popper-class="serveDrops"
                      @change="changeVacationette"
                    >
                      <el-option
                        v-for="(item, index) in vacationetteList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <p class="numPhone">
                      {{ vacationettePhone }}
                    </p>
                  </li>

                  <li class="numLi">
                    <p class="numImg">
                      <img
                        src="../../../assets/supervise/huawuIcon6.png"
                        alt=""
                        srcset=""
                      />
                    </p>
                    <el-select
                      v-model="offlineName"
                      placeholder="暂无数据"
                      class="numSelect"
                      popper-class="serveDrops"
                      @change="changeOffline"
                    >
                      <el-option
                        v-for="(item, index) in offlineList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <p class="numPhone">
                      {{ offlinePhone }}
                    </p>
                  </li>
                  <li class="numLi">
                    <p class="numImg">
                      <img
                        src="../../../assets/supervise/huawuIcon7.png"
                        alt=""
                        srcset=""
                      />
                    </p>
                    <el-select
                      v-model="workName"
                      placeholder="暂无数据"
                      class="numSelect"
                      popper-class="serveDrops"
                      @change="changeWork"
                    >
                      <el-option
                        v-for="(item, index) in workList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <p class="numPhone">{{ workPhone }}</p>
                  </li>
                </ul>
                <!-- <el-pagination
                                    class="pages"
                                    background
                                    layout="total, prev, pager, next"
                                    @current-change="handleCurrentChange"
                                    :total="page.total"
                                    :current-page.sync="page.pageNo"
                                    :page-size="10"
                                >
                                </el-pagination> -->
              </div>
              <div class="rightItem rightItem2">
                <div class="recondTitle">坐席统计</div>
                <img
                  src="../../../assets/supervise/rightBox2.png"
                  alt=""
                  srcset=""
                  class="reconbg"
                />
                <ul class="scrollTop">
                  <li class="liItem">登录名</li>
                  <li class="liItem liItem2">来电时间</li>
                  <li class="liItem">姓名</li>
                  <li class="liItem">时长</li>
                </ul>
                <div class="scrollHidden">
                  <vue-seamless-scroll
                    :style="{
                      height: 210 + 'px',
                    }"
                    :data="tableData"
                    :class-option="classOption"
                    class="warp-content"
                  >
                    <ul
                      class="scrollItem"
                      v-for="(item, index) in tableData"
                      :key="index"
                    >
                      <li class="liItem">
                        {{ item.loginName }}
                      </li>
                      <li class="liItem liItem2">
                        {{ item.startTime }}
                      </li>
                      <li class="liItem">
                        {{ item.customerName }}
                      </li>
                      <li class="liItem">
                        {{ item.connectTimeLen }}
                      </li>
                    </ul>
                  </vue-seamless-scroll>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <traffic-open
      v-if="trafficState"
      :openData="trafficInfo"
      @contactTap="contactTap"
    ></traffic-open>
  </div>
</template>
<script>
import trafficOpen from "../components/trafficOpen.vue"
import chinaJson from "echarts/map/json/china.json"
import request from "@/utils/request.js"

export default {
  components: {
    trafficOpen,
  },
  props: {
    userId: {
      type: String,
      default:
        "06a942d7-0241-4428-8f6f-bbf0695e60ae73a87e63-be16-4ed4-be70-876513c50dec",
    },
    aghents: {},
  },

  data() {
    return {
      vodelist: [
          {
              token: "",
              channel: "",
              token:""
          },
          {
              token: "",
              channel: "",
              token:""
          },
          {
              token: "",
              channel: "",
              token:""
          },
      ],
      page: { pageNo: 1, pageSize: 10, total: 0 },
      numOrgId: "",
      blindPhone: "",
      trafficInfo: {},
      trafficState: false,
      currentIndex: null,
      onFullScreen: false,
      worksInfo: {
        count0: 0,
        count1: 0,
        count2: 0,
        count3: 0,
        count4: 0,
        count5: 0,
        count6: 0,
        allCount: 0,
        oldManCount: 0,
      },
      tableData: [],
      updataPhone: null,
      updataTime: null,
      updataMap: null,
      clearPhome: null,
      clearTime: null,
      clearMap: null,
      outCall: 0,
      visible: false,
      notReady: "", //未就绪
      readyPhone: "",
      readyState: false,
      readyList: [],
      freeName: "", //置闲
      freePhone: "",
      freeState: false,
      freeList: [],
      registerName: "", //拨号
      registerState: false,
      registerPhone: "",
      registerList: [],
      keepName: "", //保持
      keepState: false,
      keepList: [],
      keepPhone: "",
      transferName: "", //转接
      transferState: false,
      transferList: [],
      offlineName: "", //离线
      offlineState: false,
      offlineList: [],
      offlinePhone: "",
      vacationetteName: "", //小休
      vacationetteState: false,
      vacationetteList: [],
      vacationettePhone: "",
      workName: "", //话后
      workState: false,
      workPhone: "",
      workList: [],
      clearNums: null,
      clearSeats: null,
      clearOntact: null,
      control:'',
      accessKey:'b73c0d5b51154959ac9f1a00a12f2bba',
      accessSecret:'cbbd0e804fc1f84e4f37c43cea95ddf8',
    }
  },
  created() {
    this.numOrgId = ""
  },
  mounted() {
    // 话务统计
    this.getMasurement()
    //时间段分析
    this.getAnalysis()
    // 话务数量
    this.masurementNums()
    //监控
    // this.getvode()
     this.getvodes()
    // 坐席统计
    this.getSeats()
    // 地图问题
    this.getMapInfo()
    // 坐席
    this.contactChange()
    const self = this
    document.addEventListener(
      "fullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "msfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "mozfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "webkitfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )
  },
  computed: {
    classOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
    statusDic() {
      console.log(this.$store.state.statusDic, "内容")
      return this.$store.state.statusDic
    },
    stateId() {
      console.log(this.$store.state.stateId, "状态id")
      return this.$store.state.stateId
    },
    holdText() {
      console.log(this.$store.state.holdText, "状态名称")
      return this.$store.state.holdText
    },
    restState() {
      console.log(this.$store.state.restState, "状态")
      return this.$store.state.restState
    },
    aghentPhone: {
      get() {
        return this.$store.getters.centerPhone
          ? this.$store.getters.centerPhone
          : ""
      },
      set(newsData) {
        this.$store.dispatch("setPhone", newsData)
      },
    },
  },
  methods: {
    //获取监控链接
    getvode(){
      fetch("https://open.ys7.com/api/lapp/token/get", {
          method: "POST", // or 'PUT'
          body: `appKey=${this.accessKey}&appSecret=${this.accessSecret}`, 
          headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          },
      }).then((res) => res.json()).then((res) => {
          this.control = res.data.accessToken
      })
    },
    getvodes() {
        this.$http
          .request({
            url: "ypt/admin/monitorManagement/info/getMonitor",
            method: "POST",
            data: {
              flag: 5,
            },
          })
          .then((res) => {
            if(res.code==200) {
              if(res.content) {
                this.vodelist=res.content
                // console.log(this.vodelist[0].token, "监控")
              }
            }
          })
      },
    // 分页
    handleCurrentChange(val) {
      this.page.pageNo = val
    },
    // 切换未就绪
    changeReady(val) {
      this.readyList.forEach((item) => {
        if (val == item.label) {
          this.readyPhone = item.phone
        }
      })
    },
    // 置闲
    changeFree(val) {
      this.freeList.forEach((item) => {
        if (val == item.label) {
          this.freePhone = item.phone
        }
      })
    },
    // 拨号
    changeRegister(val) {
      this.registerList.forEach((item) => {
        if (val == item.label) {
          this.registerPhone = item.phone
        }
      })
    },
    // 保持
    changeKeep(val) {
      this.keepList.forEach((item) => {
        if (val == item.label) {
          this.keepPhone = item.phone
        }
      })
    },
    // 小休
    changeVacationette(val) {
      this.vacationetteList.forEach((item) => {
        if (val == item.label) {
          this.vacationettePhone = item.phone
        }
      })
    },
    // 离线
    changeOffline(val) {
      this.offlineList.forEach((item) => {
        if (val == item.label) {
          this.offlinePhone = item.phone
        }
      })
    },
    // 话后处理
    changeWork(val) {
      this.workList.forEach((item) => {
        if (val == item.label) {
          this.workPhone = item.phone
        }
      })
    },
    // 地图问题
    getMapInfo() {
      const that = this
      // if (this.$store.state.statusDic != 0) {
      request({
        url: "/jjyl/home/care/info/findList",
        method: "POST",
        data: {},
      }).then((res) => {
        if (res.code === 200) {
          // console.log("地图打点", res.content)
          if (res.content) {
            let day = []
            res.content.forEach((item, index) => {
              let obj = {}
              obj.name = item.organizationName
              obj.value = []
              obj.value[0] = item.longitude
              obj.value[1] = item.latitude
              obj.value[2] = 10
              obj.value[2] = item.trafficVolume ? item.trafficVolume : 0
              obj.dataId = item.dataId
              day.push(obj)
            })
            if (this.updataMap == null) {
              this.getMaps(day) //地图
            } else {
              var option = this.updataMap.getOption()
              option.series[0].data = day
            }
          }
        }
      })
      // }
      this.clearMap = setTimeout(() => {
        this.getMapInfo()
      }, 5000)
    },

    // 时间段分析
    getAnalysis() {
      const that = this
      // if (this.$store.state.statusDic != 0) {
      request({
        url: "/jjyl/traffic/callInfo/info/getcallStatisticsInComing",
        method: "POST",
        data: {},
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            let day = [],
              count = []
            res.content.timeList.forEach((item) => {
              let timeStr = item.timeStr.substring(
                item.timeStr.length - 2,
                item.timeStr.length
              )
              day.push(timeStr)
            })
            res.content.countList.forEach((item) => {
              count.push(item.count)
            })

            if (this.updataTime == null) {
              this.timeAnalysis(day, count) //话务统计
            } else {
              var option = this.updataTime.getOption()
              option.xAxis.data = day
              option.series[0].data = count
            }
          }
        } else {
          this.$message.error(res.message)
        }
      })
      // }

      this.clearTime = setTimeout(() => {
        this.getAnalysis()
      }, 5000)
    },
    // 坐席统计
    getSeats() {
      const that = this
      // if (this.$store.state.statusDic != 0) {
      request({
        url: "/jjyl/traffic/callInfo/info/findSeatInfoList",
        method: "POST",
        data: {},
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.tableData = res.content
          }
        }
      })
      // }
      this.clearSeats = setTimeout(() => {
        this.getSeats()
      }, 5000)
    },
    //  话务数量
    masurementNums() {
      const that = this
      // if (this.$store.state.statusDic != 0) {
      request({
        url: "/jjyl/agentState/info/info",
        method: "POST",
        data: {},
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            const content = res.content.content
            this.worksInfo = {
              count0: content.countInfo ? content.countInfo.count0 : 0,
              count1: content.countInfo ? content.countInfo.count1 : 0,
              count2: content.countInfo ? content.countInfo.count2 : 0,
              count3: content.countInfo ? content.countInfo.count3 : 0,
              count4: content.countInfo ? content.countInfo.count4 : 0,
              count5: res.content.countInfo ? content.countInfo.count5 : 0,
              count6: content.countInfo ? content.countInfo.count6 : 0,
              allCount: content.allCount ? content.allCount : 0,
              oldManCount: content.oldManCount ? content.oldManCount : 0,
            }
          }
        }
      })
      // }
      this.clearNums = setTimeout(() => {
        this.masurementNums()
      }, 5000)
    },
    // 话务统计
    getMasurement() {
      const that = this
      // if (this.$store.state.statusDic != 0) {
      request({
        url: "/jjyl/traffic/callInfo/info/getcallStatisticsForSupervise",
        method: "POST",
        data: {},
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            let day = [],
              xCount = [],
              yCount = []
            res.content.dayList.forEach((item) => {
              day.push(item.day)
            })
            res.content.inCountList.forEach((item) => {
              xCount.push(item.count)
            })
            res.content.outCountList.forEach((item) => {
              yCount.push(item.count)
            })
            if (this.updataPhone == null) {
              this.phoneStyle(day, xCount, yCount) //话务统计
            } else {
              var option = this.updataPhone.getOption()
              option.xAxis.data = day
              option.yAxis.data = xCount
              option.series[0].data = yCount
            }
          }
        } else {
          this.$message.error(res.message)
        }
      })
      // }

      this.clearPhome = setTimeout(() => {
        this.getMasurement()
      }, 5000)
    },

    // 话务信息
    phoneInfo() {
      const that = this
      request({
        url: "/jjyl/traffic/callInfo/info/findSeatInfo",
        method: "POST",
        data: {
          agentID: this.callIdDic,
          outCall: this.outCall,
        },
      }).then((res) => {
        if (res.code === 200) {
          that.trafficState = true
          that.trafficInfo = {
            state: true,
            phone: res.content.phone,
            outCall: that.outCall,
            callid: res.content.callID,
            callmanid: res.content.callmanid,
            callman: res.content.callman,
          }
        }
      })
    },
    // 话务弹窗
    contactTap() {
      this.trafficInfo = {}
      this.trafficState = false
    },

    // 区域图
    getMaps(dataMap) {
      console.log("柱子数据", dataMap)
      const self = this
      this.updataMap = this.$echarts.init(document.getElementById("mapCity"))
      let option

      self.$echarts.registerMap("chinaMap", chinaJson)

      option = {
        grid: {
          left: 10,
          right: 0,
          bottom: 20,
          top: 0,
        },
        tooltip: {
          show: true,
          formatter: (params) => {
            // console.log(params.value[2], "地图闲下")
            let nums = Number(params.value[2]).toFixed(2)
            let data = params.name + "<br/>" + "话务量:" + params.value[2]
            return data
          },
        },

        geo3D: {
          map: "chinaMap",
          roam: false,
          aspectScale: 0.7, //长宽比
          boxHeight: 20,
          autoRotate: false,
          viewControl: {
            distance: 110,
            center: [0, 0, 5],
          },

          itemStyle: {
            color: "#1d5e98",
            opacity: 1,
            borderWidth: 0.4,
            borderColor: "#000",
          },
          label: {
            show: false,
            distance: 1,
            textStyle: {
              color: "#fff",
              fontSize: 8,
              backgroundColor: "transparent",
            },
          },
          emphasis: {
            silent: true,
            show: false,
            //当鼠标放上去  地区区域是否显示名称
            label: {
              show: false,
              textStyle: {
                color: "#fff",
                fontSize: 10,
                backgroundColor: "rgba(0,23,11,0)",
              },
            },
          },
          //shading: 'lambert',
          light: {
            //光照阴影
            main: {
              color: "#fff", //光照颜色
              intensity: 1.2, //光照强度
              //shadowQuality: 'high', //阴影亮度
              shadow: false, //是否显示阴影
              alpha: 55,
              beta: 10,
            },
            ambient: {
              intensity: 0.3,
            },
          },
        },
        map3D: {
          zoom: 0.4,
        },

        series: [
          {
            name: "区域",
            type: "bar3D",
            coordinateSystem: "geo3D",
            barSize: 2, //柱子粗细
            shading: "lambert",
            opacity: 1,
            bevelSize: 1,
            color: "#97bdff",
            label: {
              show: false,
              formatter: "{b}",
            },
            // data: [],
            data: dataMap,
          },
        ],
      }
      if (option && typeof option === "object") {
        this.updataMap.setOption(option, true)
        this.updataMap.on("click", function (params) {
          self.numOrgId = params.data.orgId
          self.contactChange(params)
        })
      }
    },
    // 切换
    contactChange() {
      const self = this
      self.readyList = []
      self.freeList = []
      self.registerList = []
      self.keepList = []
      self.offlineList = []
      self.vacationetteList = []
      self.workList = []
      request({
        url: "/jjyl/agentState/info/findSeat",
        method: "POST",
        data: { orgId: self.numOrgId == "" ? null : self.numOrgId },
      }).then((res) => {
        if (res.code === 200) {
          console.log(res.content, "点击数据")

          if (res.content) {
            res.content.forEach((item) => {
              if (
                item.actionType == -1 &&
                item.mobile != null &&
                item.userName != null
              ) {
                self.offlineList.push({
                  label: item.userName,
                  value: item.userName,
                  phone: item.mobile,
                })
              }
              if (
                item.actionType == 0 &&
                item.mobile != null &&
                item.userName != null
              ) {
                self.freeList.push({
                  label: item.userName,
                  value: item.userName,
                  phone: item.mobile,
                })
              }
              if (
                item.actionType == 2 &&
                item.mobile != null &&
                item.userName != null
              ) {
                self.readyList.push({
                  label: item.userName,
                  value: item.userName,
                  phone: item.mobile,
                })
              }
              if (
                item.actionType == 3 &&
                item.mobile != null &&
                item.userName != null
              ) {
                self.keepList.push({
                  label: item.userName,
                  value: item.userName,
                  phone: item.mobile,
                })
              }
              if (
                item.actionType == 4 &&
                item.mobile != null &&
                item.userName != null
              ) {
                self.registerList.push({
                  label: item.userName,
                  value: item.userName,
                  phone: item.mobile,
                })
              }

              if (
                item.actionType == 6 &&
                item.mobile != null &&
                item.userName != null
              ) {
                self.vacationetteList.push({
                  label: item.userName,
                  value: item.userName,
                  phone: item.mobile,
                })
              }
              if (
                item.actionType == 5 &&
                item.mobile != null &&
                item.userName != null
              ) {
                self.workList.push({
                  label: item.userName,
                  value: item.userName,
                  phone: item.mobile,
                })
              }
            })
            if (self.readyList.length > 0) {
              self.notReady = self.readyList[0].label
              self.readyPhone = self.readyList[0].phone
              // console.log(self.readyList,'未就绪')
            }
            if (self.freeList.length > 0) {
              self.freeName = self.freeList[0].label
              self.freePhone = self.freeList[0].phone
              // console.log(self.freeList,'置闲')
            }
            if (self.registerList.length > 0) {
              self.registerName = self.registerList[0].label
              self.registerPhone = self.registerList[0].phone
              // console.log(self.freeList,'拨号')
            }
            if (self.keepList.length > 0) {
              self.keepName = self.keepList[0].label
              self.keepPhone = self.keepList[0].phone
              // console.log(self.freeList,'保持')
            }
            if (self.workList.length > 0) {
              self.workrName = self.workList[0].label
              self.workPhone = self.workList[0].phone
              // console.log(self.freeList,'话后处理')
            }
            if (self.offlineList.length > 0) {
              self.offlineName = self.offlineList[0].label
              self.offlinePhone = self.offlineList[0].phone
              // console.log(self.freeList,'离线')
            }
            if (self.vacationetteList.length > 0) {
              self.vacationetteName = self.vacationetteList[0].label
              self.vacationettePhone = self.vacationetteList[0].phone
              // console.log(self.freeList,'小休')
            }
            // this.clearOntact = setTimeout(() => {
            //     this.contactChange()
            // }, 5000)
          }
        }
      })
    },

    // 时间段分析
    timeAnalysis(xData, yData) {
      this.updataTime = this.$echarts.init(
        document.getElementById("timeAnalysis")
      )
      var option
      option = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1, //这里是为了突出显示加上的
            },
          },
          // axisLabel: {
          //     interval: 0,
          //     rotate: 40,
          // },
          data: xData,
        },
        grid: {
          left: "12%",
          right: "12%",
          bottom: 30,
          top: 30,
        },
        color: ["#2CD1C0"],
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        series: [
          {
            data: yData,
            type: "bar",
            showBackground: true,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#fff",
                    fontSize: 14,
                  },
                },
              },
            },
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
          },
        ],
      }
      option && this.updataTime.setOption(option)
    },
    // 话务统计
    phoneStyle(xData, callInData, callOutData) {
      this.updataPhone = this.$echarts.init(
        document.getElementById("trafficWay")
      )
      var option
      option = {
        tooltip: {
          trigger: "axis",
        },
        color: ["#FBB828", "#0E3FB8"],
        legend: {
          data: ["呼入", "呼出"],
          left: "20",
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xData,
          // axisLabel: {
          //     interval: 0,
          //     rotate: 40,
          // },
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        series: [
          {
            name: "呼入",
            type: "line",
            data: callInData,
          },
          {
            name: "呼出",
            type: "line",
            data: callOutData,
          },
        ],
      }
      option && this.updataPhone.setOption(option)
    },
    // 控制全屏展示
    showFullScreen() {
      this.onFullScreen = !this.onFullScreen
      if (this.onFullScreen) {
        var docElm = document.documentElement
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen()
        } else if (docElm.msRequestFullscreen) {
          docElm = document.body //overwrite the element (for IE)
          docElm.msRequestFullscreen()
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen()
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen()
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        }
      }
      window.addEventListener("resize", () => {
        this.updataPhone.resize()
        this.updataTime.resize()
        this.updataMap.resize()
      })
    },
    FullCreeen(element) {
      let el = document.getElementById("bigdata")
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen
      if (typeof rfs != "undefined" && rfs) {
        rfs.call(el)
      } else if (typeof window.ActiveXObject != "undefined") {
        let wscript = new ActiveXObject("WScript.Shell")
        if (wscript != null) {
          wscript.SendKeys("{F11}")
        }
      }
    },
  },

  beforeDestroy() {
    clearTimeout(this.clearPhome)
    clearTimeout(this.clearTime)
    clearTimeout(this.clearNums)
    clearTimeout(this.clearSeats)
    clearTimeout(this.clearMap)
    clearTimeout(this.clearOntact)
  },
}
</script>
<style lang='less' scoped>
.recondMain {
  position: relative;
  background: #041235 url(../../../assets/supervise/contentBg.png) center bottom;
  background-size: cover;
  width: 100%;

  .recondTop {
    text-align: center;

    img {
      width: 100%;
    }
  }

  .recondContent {
    padding: 12px;
    display: flex;
    // align-items: center;
    // justify-content: center;
    .contentLeft {
      width: 28%;
    }

    .leftItem {
      width: 100%;
      position: relative;
      text-align: center;
      margin-bottom: 16px;

      .recondTitle {
        text-align: left;
        padding: 0 20px;
        line-height: 50px;
        color: #fff;
        font-size: 18px;
      }

      .reconbg {
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        position: absolute;
      }

      .videoImg {
        width: 86%;
      }

      &.leftItem1 {
        height: 32vh;
        // background: url(../../../assets/supervise/leftBox1.png)
        //     no-repeat;
        // background-size: cover;
      }

      &.leftItem2 {
        height: 24vh;
        // background: url(../../../assets/supervise/leftBox2.png)
        //     no-repeat;
        // background-size: cover;
      }
    }

    .contentRight {
      flex: 1;
      // margin-left: 12px;
      .rightTop {
        display: flex;
        // align-items: center;
        // justify-content: center;
        .topItem {
          flex: 1;
          position: relative;
          margin-left: 12px;
          height: 15vh;

          .rightImg {
            position: absolute;
            left: 0;
            top: 0px;
            width: 100%;
            height: 100%;
          }
        }
      }

      .statisticsBox {
        display: flex;
        padding: 10px;
        margin-top: 13%;
        align-items: center;
        justify-content: center;

        .icons {
          width: 60px;
          height: 60px;
        }

        .statisticsFlex {
          flex: 1;
          margin-left: 10px;

          .name {
            color: #fff;
            font-size: 20px;
          }

          .sums {
            color: #fbb828;
            font-size: 30px;
            padding-top: 10px;
          }
        }
      }

      .rightMain {
        margin-top: 12px;
        display: flex;
        margin-left: 12px;

        .rightFlex {
          flex: 1;
          margin-right: 12px;

          .recondTotal {
            line-height: 30px;
            color: #fff;
            font-size: 16px;

            .men {
              color: #fa7093;
              font-size: 20px;
              padding: 0 5px;
            }

            .total {
              color: #2cd1c0;
              font-size: 20px;
              padding: 0 5px;
            }
          }
        }

        .rightEachrt {
          width: 30%;

          .rightItem {
            width: 100%;
            position: relative;
            margin-bottom: 16px;

            .recondTitle {
              padding: 0 20px;
              line-height: 50px;
              color: #fff;
              font-size: 18px;
            }

            .reconbg {
              width: 100%;
              height: 100%;
              left: 0;
              top: 0;
              position: absolute;
            }

            .scrollHidden {
              height: 210px;
              overflow: hidden;
              margin-top: 15px;
            }

            .scrollTop {
              display: flex;
              text-align: center;
              height: 40px;

              font-size: 13px;
              background: linear-gradient(to right, #2e9eff, #061a4d);

              .liItem {
                flex: 1;
                color: #fff;
                line-height: 40px;
              }

              .liItem2 {
                flex: 2;
              }
            }

            .scrollItem {
              font-size: 13px;
              color: #2e9eff;
              margin: 0 10px;
              display: flex;
              line-height: 24px;

              .liItem {
                flex: 1;
              }

              .liItem2 {
                flex: 2;
              }
            }

            &.rightItem1 {
              height: 37vh;
              .numUl {
                position: relative;
                z-index: 2000;
                display: flex;
                flex-wrap: wrap;
                .numLi {
                  width: 30%;
                  margin-left: 2.5%;
                  .numSelect {
                    width: 100%;
                  }
                  .numPhone {
                    color: #087ab4;
                    padding-left: 15px;
                    height: 20px;
                    line-height: 20px;
                    font-size: 12px;
                  }
                  .numImg {
                    img {
                      width: 100%;
                    }
                  }
                }
              }
            }

            &.rightItem2 {
              height: 37vh;
            }
          }
        }
      }
    }
  }
}

.quanp {
  position: absolute;
  top: 20px;
  right: 10px;
  z-index: 100;

  button {
    padding: 10px;
  }
}

#trafficWay,
#timeAnalysis {
  width: 100%;
  height: 25vh;
}

#timeAnalysis {
  height: 17vh;
}
.mapCity {
  width: 100%;
  height: 67vh;
  margin-top: 13px;
}

.login {
  width: 100%;
  height: 100%;
  background: url(../../../assets/image112/bgimg.jpg);
}

.bg-particles {
  position: relative;

  img {
    animation: circle 100s infinite linear;
    width: 1200px;
    height: 1200px;
    overflow: hidden;
    border-radius: 100%;
    position: absolute;
    left: -180px;
  }
  //& > div:first-child {
  //  animation: circle 20s infinite linear;
  //  width: 1200px;
  //  height: 1200px;
  //  overflow: hidden;
  //  border-radius: 100%;
  //  position: absolute;
  //}
}

@keyframes circle {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
/deep/.el-input__inner {
  background: none;
  border: none;
  color: #087ab4;
}
/deep/.el-select-dropdown {
  background-color: #2e6ba4 !important;
}
/deep/.el-select-dropdown__item {
  color: #6ebcff !important;
}
.pages {
  padding: 0 10px;
  margin-top: 10px;
  /deep/.el-icon {
    top: 8px !important;
  }
}
</style>
<style lang="less">
.serveDrops {
  background-color: #2e6ba4 !important;
  border: 1px solid #2e6ba4;
  .el-select-dropdown__item {
    color: #6ebcff;
  }
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background: #003f7a;
  }
  .popper__arrow::after {
    border-bottom-color: #2e6ba4 !important;
  }
}
</style>
